var _defs, _path, _g, _path2, _text, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRi3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 447.275,
    height: 111.109,
    viewBox: "0 0 447.275 111.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1357",
    "data-name": "Rectangle 1357",
    width: 36.266,
    height: 36.266,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    width: 83.486,
    height: 83.485,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(-843.211 -2910.363)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M524.421,206.736h258.6a55.554,55.554,0,0,1,55.553,55.554v0a55.554,55.554,0,0,1-55.553,55.553h-258.6a22.629,22.629,0,0,1-17.324-8.069l-32.315-38.445a14.047,14.047,0,0,1,0-18.081L507.1,214.805a22.629,22.629,0,0,1,17.324-8.069",
    transform: "translate(393.141 2703.627)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(843.211 2948.665)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M458.6,247.914a18.133,18.133,0,1,0,18.133-18.133A18.134,18.134,0,0,0,458.6,247.914",
    transform: "translate(-458.601 -229.782)",
    fill: "#ff8206"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M464.663,243.9a8.058,8.058,0,1,0,8.058-8.058,8.059,8.059,0,0,0-8.058,8.058",
    transform: "translate(388.623 2722.897)",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Symmetry_with_vendor_production_schedules",
    "data-name": "Symmetry with vendor  production schedules",
    transform: "translate(912 2965)",
    fontSize: 20,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Symmetry with vendor "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "production schedules"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(1207 2923)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M677.276,256.3a41.743,41.743,0,1,0,41.742-41.742A41.742,41.742,0,0,0,677.276,256.3",
    transform: "translate(-677.276 -214.558)",
    fill: "#ff8206"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M686.22,250.379A26.877,26.877,0,1,0,713.1,223.5a26.877,26.877,0,0,0-26.877,26.877",
    transform: "translate(535.78 2714.498)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    transform: "translate(-3083.983 -791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M41.868,35.972a6.442,6.442,0,1,0,5.909,6.417,6.464,6.464,0,0,0-5.909-6.417Zm1.85,6.974s-2.38-.024-2.385-.021a.535.535,0,0,1-.529-.535L40.8,38.646a.535.535,0,1,1,1.07,0V41.86l1.856.016a.535.535,0,1,1-.005,1.07Z",
    transform: "translate(4299.063 3722.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M14.254,7.8V4.52a.535.535,0,1,0-1.07,0V7.8a.535.535,0,1,0,1.07,0Z",
    transform: "translate(4309.179 3737.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M38.827,7.8V4.52a.535.535,0,1,0-1.07,0V7.8a.535.535,0,1,0,1.07,0Z",
    transform: "translate(4297.729 3737.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M26.776,21.451a6.018,6.018,0,0,1,1.155-.011V8.664a1.609,1.609,0,0,0-1.6-1.6h-1.7V9.236a1.6,1.6,0,1,1-3.209,0V7.06H11.5V9.236a1.6,1.6,0,1,1-3.209,0V7.06H6.587a1.609,1.609,0,0,0-1.6,1.6V32.778a1.609,1.609,0,0,0,1.6,1.6H22.241q-.176-.16-.337-.337A7.532,7.532,0,0,1,26.776,21.451Zm-5.4-7.829h3.284a.535.535,0,1,1,0,1.07H21.38a.535.535,0,1,1,0-1.07Zm0,5.107h3.284a.535.535,0,1,1,0,1.07H21.38a.535.535,0,1,1,0-1.07Zm-6.562-5.107H18.1a.535.535,0,1,1,0,1.07H14.818a.535.535,0,1,1,0-1.07Zm0,5.107H18.1a.535.535,0,1,1,0,1.07H14.818a.535.535,0,1,1,0-1.07ZM8.256,13.622h3.278a.535.535,0,1,1,0,1.07H8.256a.535.535,0,1,1,0-1.07Zm0,5.107h3.278a.535.535,0,1,1,0,1.07H8.256a.535.535,0,1,1,0-1.07Zm3.278,11.279H8.256a.535.535,0,1,1,0-1.07h3.278a.535.535,0,1,1,0,1.07Zm0-5.107H8.256a.535.535,0,1,1,0-1.07h3.278a.535.535,0,1,1,0,1.07ZM18.1,30.008H14.818a.535.535,0,1,1,0-1.07H18.1a.535.535,0,1,1,0,1.07Zm0-5.107H14.818a.535.535,0,1,1,0-1.07H18.1a.535.535,0,1,1,0,1.07Z",
    transform: "translate(4313 3735.582)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi3);
export default __webpack_public_path__ + "static/media/ri3.f88b7c6cdf74a30df442f1640b6440b8.svg";
export { ForwardRef as ReactComponent };